import React, { Component } from "react";

export default class Filter extends Component {
  constructor(props) {
    super(props);
    this.state = { filter: { order: "" }, models: [], makes: [] , modelTypes: []};
  }

  componentDidMount = () => {
    let allModelsTypes = [];
    let allMakes = [];
    
    Object.keys(this.props.models).map((m) => {
      allModelsTypes[this.props.models[m].acf.model] = 1;
      allMakes[this.props.models[m].acf.make.value] =
        this.props.models[m].acf.make.label;
    });
    this.setState(
      {
        makes: allMakes,
        models: allModelsTypes,
        filter: { order: "" },
      },
      () => this.setFilters()
    );
  };

  setFilters() {
    this.props.setFilters(this.state.filter);
  }



  handleOnChange(e) {
    const id = e.target.id;
    const val = e.target.value;
    this.setState(
      (prevState) => ({
        filter: { ...prevState.filter, [id]: val },
      }),
      () => this.setFilters()
    );
  }
  clearFilters() {
    this.setState(
      (prevState) => ({
        filter: { order: "" },
      }),
      () => this.setFilters()
    );
  }
  render() {
    const { filter } = this.state;

    return (
      <div className="Filter">
        <div className="Filter--topbar">
          <p className="Filter--title">Millist rendiautot eelistad?</p>
          {Object.keys(filter).length > 1 ||
          (Object.keys(filter).length === 1 && filter["order"] !== "") ? (
            <button onClick={(e) => this.clearFilters()}>
              <span>Eemalda filtrid</span> &#10005;
            </button>
          ) : (
            ""
          )}
        </div>
        <div className="Filter--inside">
          <select
            id="make"
            value={filter["make"] ? filter["make"] : ""}
            onChange={(e) => this.handleOnChange(e)}
          >
            <option disabled={filter["make"] ? true : false} selected>
              VALI MARK
            </option>
            {Object.keys(this.state.makes).map((val) => {
              return <option value={val}>{this.state.makes[val]}</option>;
            })}
          </select>

          <select
            id="model"
            value={filter["model"] ? filter["model"] : ""}
            onChange={(e) => this.handleOnChange(e)}
          >
            <option disabled={filter["model"] ? true : false} selected>
              VALI MUDEL
            </option>
            {Object.keys(this.props.modelTypes).map((val) => {
              return <option>{this.props.modelTypes[val]}</option>;
            })}
          </select>

          <select
            id="price"
            value={filter["price"] ? filter["price"] : ""}
            onChange={(e) => this.handleOnChange(e)}
          >
            <option selected disabled={filter["price"] ? true : false}>
              HIND KUNI
            </option>
            <option>400</option>
            <option>500</option>
            <option>600</option>
            <option>700</option>
            <option>800</option>
          </select>
          
          <select
            id="transmission"
            value={filter["transmission"] ? filter["transmission"] : ""}
            onChange={(e) => this.handleOnChange(e)}
          >
            <option selected disabled={filter["transmission"] ? true : false}>
              KÄIGUKAST
            </option>
            <option>manuaal</option>
            <option>automaat</option>
          </select>

          <select
            id="fuel"
            value={filter["fuel"] ? filter["fuel"] : ""}
            onChange={(e) => this.handleOnChange(e)}
          >
            <option selected disabled={filter["fuel"] ? true : false}>
              KÜTUS
            </option>
            <option>bensiin</option>
            <option>diisel</option>
            <option>elekter</option>
            <option>hübriid</option>
          </select>

          <select
            id="order"
            value={filter["order"] ? filter["order"] : ""}
            onChange={(e) => this.handleOnChange(e)}
          >
            <option
              value={""}
              selected
              disabled={filter["order"] ? true : false}
            >
              SORTEERI
            </option>
            <option value="lowtohigh">SOODSAMAD ENNE</option>
            <option value="hightolow">KALLIMAD ENNE</option>
          </select>
        </div>
      </div>
    );
  }
}
//            <option value="noreserved">VABAD AUTOD EES</option>
